export default __webpack_public_path__ + "static/smile-0fa22602aab80eab317b19bf003c3758.jpg";